.wrap {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  min-width: 0;
}
.scroll {
  overflow-x: auto;
}
.virtual {
  overflow-y: auto;
}
.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: var(--text-sm);
}
.th {
  position: sticky;
  top: 0;
  z-index: 1;
  text-align: start;
  padding: 12px 16px;
  background: var(--color-surface-2);
  border-block-end: 1px solid var(--color-border);
  color: var(--color-text-muted);
  font-size: var(--text-xs);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}
.td {
  padding: 12px 16px;
  border-block-end: 1px solid var(--color-border);
  vertical-align: middle;
}
.tr:last-child .td {
  border-block-end: 0;
}
.tr:hover {
  background: var(--color-surface-2);
}
.clickable {
  cursor: pointer;
}
.selected,
.selected:hover {
  background: var(--color-accent-soft);
}
.check {
  width: 44px;
  padding-inline-end: 0;
}
.end {
  text-align: end;
}
.center {
  text-align: center;
}
.sortBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}
.sortBtn:hover {
  color: var(--color-text);
}
.muted {
  opacity: 0.5;
}
.emptyCell {
  padding: var(--space-10) var(--space-4);
  text-align: center;
  color: var(--color-text-muted);
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: 10px 16px;
  border-block-start: 1px solid var(--color-border);
}
.footText {
  font-size: var(--text-xs);
  color: var(--color-text-subtle);
  font-weight: 600;
}
.pager {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
@media (max-width: 720px) {
  .hideMobile {
    display: none;
  }
}
